import { render, staticRenderFns } from "./GoogleBusinessProfile.vue?vue&type=template&id=7844d51e&scoped=true&"
import script from "./GoogleBusinessProfile.vue?vue&type=script&lang=js&"
export * from "./GoogleBusinessProfile.vue?vue&type=script&lang=js&"
import style0 from "./GoogleBusinessProfile.vue?vue&type=style&index=0&id=7844d51e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7844d51e",
  null
  
)

export default component.exports